export default __webpack_public_path__ + "static/media/ganapathi.c60524db.svg";